// ─── Sari Palace — Homepage JS ───

// Mobile menu toggle
function spToggleMenu() {
  const m = document.getElementById('sp-mobile-menu');
  if (!m) return;
  m.style.display = m.style.display === 'flex' ? 'none' : 'flex';
}

// Nav shadow on scroll
window.addEventListener('scroll', () => {
  const nav = document.getElementById('sp-nav');
  if (nav) nav.style.boxShadow = window.scrollY > 20 ? '0 4px 32px rgba(0,0,0,0.08)' : 'none';
});

// Toast
function spShowToast(msg) {
  const t = document.getElementById('sp-toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 4000);
}

// Appointment form
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('sp-appt-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      spShowToast('Thank you — we will be in touch within 24 hours.');
      form.reset();
    });
  }
});